import React from 'react'
import PropTypes from 'prop-types'
import './App.css'
import {
  Router,
  Route,
  Switch, Redirect
} from 'react-router-dom'
import firebase from 'firebase'
import { polyglot } from '../../../index.js'
import document from '../../../resources/UsefullInformation.pdf'
import history from '../../../Auth/history'
import Auth from '../../../Auth/Auth'
import Login from '../Login/Login'
import Callback from '../../../Auth/Callback/Callback'
import Settings from '../Settings/Settings'
import NewPatientForm from '../PatientInsertion/NewPatientForm'
import DoctorProfile from '../DoctorProfile/DoctorProfile'
import PdfViewer from '../../common/PDFViewer/PdfViewer'
import Test from './Test/Test'
import NavBar from './Navigation/NavBar'
import Loading from '../../common/Loading/Loading'
import Home from '../Home/Home'
import PatientPicker from '../PatientPicker/PatientPicker'
import Age from '../Age/Age'
import PatientData from '../PatientData/PatientData'
import FluorInfo from '../FluorInfo/FluorInfo'
import ErrorBoundary from '../../common/ErrorBoundary/ErrorBoundary'

const auth = new Auth()

const handleAuthentication = ({location}) => {
  if (/access_token|id_token|error/.test(location.hash)) {
    auth.handleAuthentication()
  }
}

export default class App extends React.Component {
  constructor (props) {
    super(props)
    this.getConfiguration = this.getConfiguration.bind(this)
    this.logOut = this.logOut.bind(this)
    this.setCurrentPatientAges = this.setCurrentPatientAges.bind(this)
    this.setCurrentPatientId = this.setCurrentPatientId.bind(this)
    this.state = {
      isAuthenticated: undefined,
      user: undefined,
      currentPatientAges: undefined,
      configuration: undefined,
      currentPatientId: undefined
    }
  }

  logOut () {
    this.setState({
      patient: undefined,
      currentPatientId: undefined,
      currentPatientAges: undefined,
      isAuthenticated: false,
      user: undefined
    })
    auth.logout()
    // dataAppAuth.signOut()
  }

  getConfiguration () {
    const rootRef = firebase.database().ref()
    const configurationRef = rootRef.child('riso').child('configuration')
    configurationRef.on('value', snapshot => {
      this.setState({
        configuration: snapshot.val()
      })
    })
  }

  componentWillMount () {
    this.getConfiguration()
    if (auth.isAuthenticated()) {
      auth.getProfile((error, profile) => {
        if (error) {
          // window.myLogger.error(error)
        }
        if (profile) {
          // window.myLogger.info(JSON.stringify({message: 'User Info Object', user: profile}))
          this.setState({
            user: profile
          })
        }
      })
    }
  }

  setCurrentPatientAges (ages) {
    this.setState({
      currentPatientAges: ages
    })
  }

  setCurrentPatientId (id) {
    this.getConfiguration()
    this.setState({
      currentPatientId: id
    })
  }

  componentWillUpdate (nextProps, nextState) {
    if (auth.isAuthenticated()) {
      if (!nextState.isAuthenticated) {
        this.setState({
          isAuthenticated: true
        })
      }
      auth.getProfile((error, profile) => {
        if (error) {
          // window.myLogger.error(error)
        }
        if (profile) {
          // window.myLogger.info(JSON.stringify({message: 'User Info Object', user: profile}))
          this.setState({
            user: profile
          })
        }
      })
    }
  }

  renderSwitch () {
    return <Switch>
      <Route exact path='/' render={props => (
        <Login auth={auth} props{...props} />
      )} />
      <Route exact path='/login' render={(props) => {
        handleAuthentication(props)
        return <Callback {...props} />
      }} />
      <Route path={`/patients`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PatientRouter
            configuration={this.state.configuration}
            setCurrentPatientAges={this.setCurrentPatientAges}
            setCurrentPatientId={this.setCurrentPatientId}
            props{...props} />
        )
      )} />
      <Route exact path={`/settings`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Settings handleLanguageChange={(polyglot => { this.setState({polyglot: polyglot}) })} props{...props} />
        )
      )} />
      <Route exact path={`/patientInsertion`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <NewPatientForm props{...props} setPatient={this.setPatient} />
        )
      )} />
      <Route exact path={`/me`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <DoctorProfile patient='Ricardo' />
        )
      )} />
      <Route exact path={`/info`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PdfViewer document={document} title={polyglot.t('commonFields.usefulInformation')} props{...props} />
        )
      )} />
      <Route path='/test' render={() => (
        <Test />
      )} />
      <Route render={function () {
        return <p>{polyglot.t('commonFields.notFound')}</p>
      }} />
    </Switch>
  }

  render () {
    if (polyglot) {
      return (
        <ErrorBoundary>
          <Router history={history} basename={process.env.REACT_APP_ROUTER_BASE_PATH}>
            {this.state.configuration ? <div className='full-screen'>
              {this.state.isAuthenticated
                  ? <NavBar
                    currentAges={this.state.currentPatientAges}
                    ages={this.state.configuration.ages}
                    setCurrentPatientId={this.setCurrentPatientId}
                    patientId={this.state.currentPatientId}
                    logOut={this.logOut} /> : null
                }
              {this.renderSwitch()}
              {/* <Footer/> */}
            </div>
              : <Loading />
            }
          </Router>
        </ErrorBoundary>
      )
    } else {
      return <Loading />
    }
  }
}

class PatientRouter extends React.Component {
  render () {
    const url = this.props.match.url
    return <Switch>
      <Route exact path={`${url}/:patientId`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Home
            props{...props}
            configuration={this.props.configuration}
            ages={this.props.configuration.ages}
            setPatientAges={this.props.setCurrentPatientAges}
            setPatientId={this.props.setCurrentPatientId} />
        )
      )} />
      <Route exact path={`${url}/`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PatientPicker
            setPatientAges={this.props.setCurrentPatientAges}
            setPatientId={this.props.setCurrentPatientId}
            props{...props} />
        )
      )} />
      <Route exact path={`${url}/:patientId/age`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <Age props{...props} setPatientId={this.props.setCurrentPatientId} />
        )
      )} />
      <Route exact path={`${url}/:patientId/profile`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <PatientData props{...props} setPatientId={this.props.setCurrentPatientId} />
        )
      )} />
      <Route exact path={`${url}/:patientId/fluor`} render={props => (
        !auth.isAuthenticated() ? (
          <Redirect to={{
            pathname: '/',
            state: { referrer: props.location.pathname }
          }} />
        ) : (
          <FluorInfo props{...props} setPatientId={this.props.setCurrentPatientId} />
        )
      )} />
    </Switch>
  }
}

PatientRouter.propTypes = {
  configuration: PropTypes.object.isRequired,
  setCurrentPatientAges: PropTypes.func.isRequired,
  setCurrentPatientId: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/general/App/App.js